import apiPesanan from '@/api/seller/pesanan';

const defaultState = () => ({
	statusPesanan: null,
	historyTrackingData: [],
	pesananData: [],
	pesananNewData: [],
	pesananPaidData: [],
	loadPesanan: false,
	detailPesanan: {},
	detailAlamat: {},
	historyUploadTerminData: [],
	historyUploadTerminPagination: '',
	historyNegoTransactionData: [],
	historyNegoTransactionPagination: '',
	pesananPagination: '',
	pesananNewPagination: '',
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alertMultiple: [],
	statusVerifikasi:[
		{
			trx_status:'pending',
			count_status:0,
		},
		{
			trx_status:'approved',
			count_status:0,
		},
		{
			trx_status:'rejected',
			count_status:0,
		},
	],
	alert: ''
});

const state = defaultState();

const getters = {};

const mutations = {
	sesthistoryUploadTerminData(state, data) {
		state.historyUploadTerminData = data.data
		state.historyUploadTerminPagination = data.pagination;
	},
	sesthistoryNegoTransactionData(state, data) {
		state.historyNegoTransactionData = data.data
		state.historyNegoTransactionPagination = data.pagination;
	},
	setHistoryTracking(state, data) {
		state.historyTrackingData = data.data
	},
	setStatus(state, data) {
		state.statusPesanan = data.data
	},
	setPesanan(state, data) {
		state.pesananData = data.data
		state.pesananPagination = data.pagination
	},
	setPaidPesanan(state, data) {
		state.pesananPaidData = data.data
		state.pesananPagination = data.pagination
	},
	setNewPesanan(state, data) {
		state.pesananNewData = data.data
		state.pesananNewPagination = data.pagination
	},
	setloadPesanan(state, data) {
		state.loadPesanan = data
	},
	setPesananDetail(state, data) {
		state.detailPesanan = data
	},
	setAlamatDetail(state, data) {
		state.detailAlamat = data
	},
	saveResponse(state, data) {
		state.response = data
		state.alertMultiple = []
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	multipleAlert(state, data) {
		state.alertMultiple = data.map((el) => {
			return {
				show: true,
				message: el
			}
		})
	},
	failed(state, data) {
		state.alert = data
	},
	clearPesanan(state) {
		Object.assign(state, defaultState());
	}
};

const actions = {
	getHistoryTracking({ commit }, params) {
		commit('setloadPesanan', true);
		return new Promise((resolve) => {
			apiPesanan.getHistoryTracking(params).then(({ data: { data } }) => {
				commit('setHistoryTracking', { data: data.results });
				resolve(true);
			}).then(() => {
				commit('setloadPesanan', false);
			});
		});
	},
	getTrackingKiriminaja({ commit }, params) {
		commit('setloadPesanan', true);
		return new Promise((resolve) => {
			apiPesanan.getTrackingKiriminaja(params).then(({ data: { data } }) => {
				commit('setPesanan', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).then(() => {
				commit('setloadPesanan', false);
			});
		});
	},
	getTracking({ commit }, params) {
		commit('setloadPesanan', true);
		return new Promise((resolve) => {
			apiPesanan.getTracking(params).then(({ data: { data } }) => {
				commit('setPesanan', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).then(() => {
				commit('setloadPesanan', false);
			});
		});
	},
	getStatusPesanan({ commit }, params) {
		return new Promise((resolve) => {
			apiPesanan.getStatusPesanan(params).then(({ data: { data } }) => {
				commit('setStatus', { data: data.results });
				resolve(true);
			}).catch(() => {
				commit('setStatus', { data: [] });
			}).then(() => {

			});
		});
	},

	getPesanan({ commit }, params) {
		commit('setloadPesanan', true);
		return new Promise((resolve) => {
			apiPesanan.getPesanan(params).then(({ data: { data } }) => {
				commit('setPesanan', { data: data.results, pagination: data.pagination });
				resolve(data);
			}).catch(() => {
				commit('setPesanan', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadPesanan', false);
			});
		});
	},
	getSummaryPesanan({ commit }, params) {
		commit('setloadPesanan', true);
		return new Promise((resolve) => {
			apiPesanan.getPesanan(params).then(({ data: { data } }) => { 
				resolve(data);
			}).catch(() => { 
			}).then(() => {
				commit('setloadPesanan', false);
			});
		});
	},
	getPesananCount({ commit }, params) {
		commit('setloadPesanan', true);
		return new Promise((resolve) => {
			apiPesanan.getPesanan(params).then(({ data: { data } }) => {
				resolve(data);
			}).catch(() => {
			}).then(() => {
				commit('setloadPesanan', false);
			});
		});
	},

	getPaidPesanan({ commit }, params) {
		commit('setloadPesanan', true);
		return new Promise((resolve) => {
			apiPesanan.getPaidPesanan(params).then(({ data: { data } }) => {
				commit('setPaidPesanan', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setPaidPesanan', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadPesanan', false);
			});
		});
	},

	getNewPesanan({ commit }, params) {
		commit('setloadPesanan', true);
		return new Promise((resolve) => {
			apiPesanan.getPesanan(params).then(({ data: { data } }) => {
				commit('setNewPesanan', { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch(() => {
				commit('setNewPesanan', { data: [], pagination: {} });
			}).then(() => {
				commit('setloadPesanan', false);
			});
		});
	},

	getPesananDetail({ commit }, params) {
		commit('setloadPesanan', true);
		return new Promise((resolve) => {
			apiPesanan.getPesananDetail(params).then(({ data: { data } }) => {
				commit('setPesananDetail', data.results);
				resolve(true);
			}).catch(() => {
				commit('setPesananDetail', {});
			}).then(() => {
				commit('setloadPesanan', false);
			});
		});
	},
	getPesananDetailShipment({ commit }, params) {
		commit('setloadPesanan', true);
		return new Promise((resolve) => {
			apiPesanan.getPesananDetailShipment(params).then(({ data: { data } }) => {
				commit('setPesananDetail', data.results);
				resolve(true);
			}).catch(() => {
				commit('setPesananDetail', {});
			}).then(() => {
				commit('setloadPesanan', false);
			});
		});
	},

	getAlamatDetail({ commit }, params) {
		return new Promise((resolve) => {
			apiPesanan.getAlamatDetail(params).then(({ data: { data } }) => {
				commit('setAlamatDetail', data.results);
				resolve(true);
			}).catch(() => {
				commit('setAlamatDetail', {});
			})
		});
	},
	prosesPesanan({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.prosesPesanan(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	kirimPesanan({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.kirimPesanan(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	paymentStorePaid({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.paymentStorePaid(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	paymentStoreCancel({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.paymentStoreCancel(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	cancelPesanan({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.cancelPesanan(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	requestPickupPesanan({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.requestPickupPesanan(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	pickupStore({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.pickupStore(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	changeResi({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.changeResi(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	updatePesananNego({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.updatePesananNego(params).then((data) => {
				dispatch('success', data.data)
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			})
		});
	},
	async historyUploadTermin({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.historyUploadTermin(params).then(({ data: { data } }) => {
				commit('sesthistoryUploadTerminData',  { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			}).then(() => {
			});
		});
	},
	async historyNegoTransaction({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.historyNegoTransaction(params).then(({ data: { data } }) => {
				commit('sesthistoryNegoTransactionData',  { data: data.results, pagination: data.pagination });
				resolve(true);
			}).catch((err) => {
				reject(true)
				const { data } = err.response;
				dispatch('errorHandler', data);
			}).then(() => {
			});
		});
	},
	async excelHistoryNegoTransaction({  commit }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.excelHistoryNegoTransaction(params).then(({ data: { data } }) => {
				resolve(data.results);
			}).catch(( ) => {
				reject(true)
			}).then(() => {
			});
		});
	},
	async exportDataTempo({  commit }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.exportDataTempo(params).then(({ data: { data } }) => {
				resolve(data.results);
			}).catch(( ) => {
				reject(true)
			}).then(() => {
			});
		});
	},
	async getSummaryRemainingDebt({  commit }, params) {
		return new Promise((resolve, reject) => {
			apiPesanan.getSummaryRemainingDebt(params).then(({ data: { data } }) => {
				resolve(data.results);
			}).catch(( ) => {
				reject(true)
			}).then(() => {
			});
		});
	},
	async uploadFinanceSubmit({ dispatch, commit }, params) {
		return new Promise(async (resolve, reject) => {
			await commit('progress', true, { root: true });
			await apiPesanan.uploadFinanceSubmit(params).then(({ data: { data } }) => {
				dispatch('success', data)
				commit('makeAlert', { code: 'success', type: 'success', message: 'Konfirmasi berhasil diproses', show: true }, { root: true });
				resolve(data);
			}).catch((err) => {
				const { data } = err.response;
				reject(data.message)
				dispatch('errorHandler', data);
			})
			await commit('progress', false, { root: true });
		});
	},
	async uploadCSSumbit({ dispatch, commit }, params) {
		return new Promise(async (resolve, reject) => {
			await commit('progress', true, { root: true });
			await apiPesanan.uploadCSSumbit(params).then(({ data: { data } }) => {
				dispatch('success', data)
				commit('makeAlert', { code: 'success', type: 'success', message: 'Konfirmasi berhasil diproses', show: true }, { root: true });
				resolve(data);
			}).catch((err) => {
				const { data } = err.response;
				reject(data.message)
				dispatch('errorHandler', data);
			})
			await commit('progress', false, { root: true });
		});
	},
	success({ commit }, response) {
		commit('saveResponse', response)
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
				commit('validationError', response.data);
				break;

			case 'error_multiple_alert':
				commit('multipleAlert', response.data.error)
				break;

			default:
				commit('makeAlert', { code: 'error_response', type: 'error', message: response.message, show: true }, { root: true });
				break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
